import { Appointment, VideoChatShiftAppointment } from '~/types/tutoring-api'

export default function appointmentIsShift(appointment: Appointment): appointment is VideoChatShiftAppointment {
  return (appointment as VideoChatShiftAppointment).sessions !== undefined
}
